<template>
  <div class="baikecontainer">
    <h1>SMALLEEL</h1>

    <h2>一、品牌名称</h2>
    <p><strong>SMALLEEL</strong></p>

    <img
      src="https://panqi-orgfish.oss-rg-china-mainland.aliyuncs.com/img/smalleellogo.png"
      width="50%"
    />

    <h2>二、品牌简介</h2>
    <p>
      SMALLEEL是辰鳗科技集团有限公司的英文注册商标，小鳗管家是辰鳗科技集团有限公司旗下能源管理平台，涵盖能源管理系统、计量收费系统、动力储能回馈系统、暖通空调节能算法控制系统、虚拟电厂、分布式光伏+储能、电力交易服务等业务模块，为政府公建、商业综合体、产业园区等场景提供能源数字化、综合微电网、虚拟电厂、光伏运营、电力交易、节能服务等解决方案。
    </p>
    <p>
      截至2025年底，业务覆盖全球6个国家243个城市，累计服务工商业电力用户数量25.77万户。
    </p>

    <h2>三、品牌/产品服务</h2>
    <p>
      小鳗管家能源管理平台融合了IoT物联网、AI算法模型、大数据分析、云边端协同等技术，实现智能计量监测设备、数据采集器与云主机之间的数据通道，构成能耗物联网生态，主营业务涵盖能源数字化管理、虚拟电厂、微电网、分布式光伏+储能、综合节能等方向。
    </p>

    <h2>四、品牌发展历程</h2>
    <ul class="timeline">
      <li>2020年6月：辰鳗科技集团有限公司成立</li>
      <li>2021年3月：项目经管系统正式上线</li>
      <li>2021年7月：辰鳗智慧能源科技（天津）有限公司成立</li>
      <li>2022年2月：获得PreA轮2000万元融资</li>
      <li>2022年3月：浙江辰鳗能源设备制造有限公司成立</li>
      <li>
        2022年6月：集团经管系统、项目能源管理系统、集团能源管理系统、水表预付系统正式上线
      </li>
      <li>2023年2月：动力储能回馈装置正式推出；同年获得A轮5000万元融资</li>
      <li>2023年3月：江苏辰鳗科技有限公司成立</li>
      <li>2023年4月：暖通空调节能算法控制系统正式上线</li>
      <li>2024年5月：能源托管平台上线</li>
      <li>2024年9月：光伏运营平台上线</li>
      <li>2024年11月：杭州辰鳗综能科技有限公司、四川蓉鳗智慧能源科技有限公司成立</li>
      <li>2025年8月：华鳗（四川）低碳科技有限公司成立</li>
      <li>2025年12月：湖南辰鳗能源科技有限公司成立</li>
    </ul>

    <h2>五、品牌文化</h2>
    <div class="info-block">
      <p>每一度，我们在服务</p>
    </div>

    <h2>六、品牌地址</h2>
    <div class="info-block">
      <div class="address-row">
        <div class="strong">集团总部（云枢大脑中心）</div>
        四川·成都·双流区电子科大科技园（天府园区）B12栋4单元4-6楼
      </div>
      <div class="address-row" style="margin-top: 12px">
        <div class="strong">华东总部（AI算法中心）</div>
        浙江·杭州·西湖区文一西路767号绿城西溪国际C座202室
      </div>
    </div>

    <h2>七、商标注册信息</h2>
    <ul class="timeline1">
      <li>商标注册号：69819055｜注册日期：2023年08月28日｜国际分类：35</li>
      <li>商标注册号：69825301｜注册日期：2023年08月28日｜国际分类：42</li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      screenWidth: document.body.clientWidth,
    };
  },
  mounted() {
    console.log(this.screenWidth);
  },
  methods: {},
};
</script>

<style>
.baikecontainer {
  max-width: 1100px;
  margin: 0 auto;
  background: #fff;
  overflow: scroll;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: left;
  height: 100vh;
}
h1 {
  text-align: center;
  color: #165dff;
  margin-bottom: 36px;
  border-bottom: 2px solid #165dff;
  padding-bottom: 12px;
}
h2 {
  color: #222;
  margin: 30px 0 16px;
  padding-left: 10px;
  border-left: 4px solid #165dff;
}
p {
  margin-bottom: 14px;
  font-size: 15px;
  line-height: 1.8;
}
ul {
  padding-left: 24px;
  margin-bottom: 16px;
}
li {
  margin: 8px 0;
}
.timeline1 li {
  list-style: none;
  position: relative;
  padding-left: 22px;
  padding-bottom: 8px;
}
.timeline1 li::before {
  content: "●";
  color: #000;
  position: absolute;
  left: 0;
}
.timeline li {
  list-style: none;
  position: relative;
  padding-left: 22px;
  padding-bottom: 8px;
}
.timeline li::before {
  content: "●";
  color: #165dff;
  position: absolute;
  left: 0;
}
.info-block {
  background: #f0f7ff;
  padding: 16px 20px;
  border-radius: 8px;
  margin: 12px 0;
}
.address-row {
  margin: 10px 0;
}
.strong {
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/page/baikeOther.vue